import { ColumnDef } from '@tanstack/react-table'

export const HiddenColumn = <T,>(): ColumnDef<T> => ({
  id: 'hidden',
  meta: {
    hidden: true,
  },
})
